import product1 from "@/assets/product/product1.png";
import product2 from "@/assets/product/product2.png";
import product3 from "@/assets/product/product3.png";
import product4 from "@/assets/product/product4.png";
import heroA from "@/assets/product/hero_a.png";
import heroB from "@/assets/product/hero_b.png";
import heroC from "@/assets/product/hero_c.png";

export const IMAGES = {
  hero: heroC,
  sunsetLiving: heroC,
  daytimeTerrace: heroB,
  collage: heroA,
  product1,
  product2,
  product3,
  product4,
  product1,
  product2,
  product3,
  product4,
  herbs:
    "https://images.unsplash.com/photo-1533792344354-ed5e8fc12494?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHxmcmVzaCUyMGhlcmJzJTIwdmVnZXRhYmxlcyUyMHJhaXNlZCUyMGdhcmRlbiUyMGNsb3NldXB8ZW58MHx8fHwxNzg2MDY0NTkxfDA&ixlib=rb-4.1.0&q=85",
  solar:
    "https://images.unsplash.com/photo-1724041875467-3576f20170dc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxzb2xhciUyMHBhbmVsJTIwZGV0YWlsJTIwbWFjcm8lMjB0ZXh0dXJlfGVufDB8fHx8MTc4NjA2NDU5MXww&ixlib=rb-4.1.0&q=85",
  evening:
    "https://images.unsplash.com/photo-1761426202710-8e4a2e8738b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBwYXRpbyUyMGV2ZW5pbmclMjB3YXJtJTIwbGlnaHRzfGVufDB8fHx8MTc4NjA2NDU5MXww&ixlib=rb-4.1.0&q=85",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
